// Angular
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-field-single-check-sm',
    templateUrl: './field-single-check-sm.component.html',
    styleUrls: ['./field-single-check-sm.component.scss'],
    standalone: false
})
export class FieldSingleCheckSmComponent {
    @Input() model = false;
}
